module.exports = __webpack_public_path__ + "img/1557614071959855105.70018abd.png";